import { Button, Col, Container, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import searchIcon from "../../../assets/images/search_rgb_red.svg";
import downloadIcon from "../../../assets/images/download_rgb_red.svg";
import "../../../assets/styles/addresses.scss";
import { useFileExport } from "../../../hooks/useFileExport";

const AddressesFillingHourlyIntervalsButtons = ({ onSearch, filters = {} }) => {
  const { exportFile, isExporting } = useFileExport(
    "/Reports/AddressesFillingHourlyIntervalsCsv",
    "addresses-filling-hourly-intervals.csv"
  );

  const handleDownloadCsv = async () => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null && v !== "") {
            queryParams.append(key, String(v));
          }
        });
      } else if (typeof value === "object") {
        const v = value.value ?? value.label ?? String(value);
        if (v) queryParams.append(key, String(v));
      } else {
        queryParams.append(key, String(value));
      }
    });
    const qs = queryParams.toString();
    if (!qs) {
      alert("Proszę wprowadzić co najmniej jeden filtr przed eksportem do pliku.");
      return;
    }

    const filtersToExport = Object.fromEntries(
      [...queryParams.entries()].map(([k, v]) => [k, v])
    );

    try {
      await exportFile(filtersToExport);
    } catch (e) {
      alert("Wystąpił błąd podczas eksportu CSV.");
    }
  };

  const renderDownloadTooltip = (props) => (
    <Tooltip id="download-tooltip" {...props}>
      Eksportuj dane spełniające kryteria
    </Tooltip>
  );

  const renderSearchTooltip = (props) => (
    <Tooltip id="search-tooltip" {...props}>
      Wyszukaj
    </Tooltip>
  );

  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderDownloadTooltip}
          >
            <Button className="addresses-button" onClick={handleDownloadCsv} disabled={isExporting}>
              <img
                src={downloadIcon}
                alt="Download"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
        <Col xs="auto">
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={renderSearchTooltip}
          >
            <Button className="addresses-button" onClick={onSearch}>
              <img
                src={searchIcon}
                alt="Search"
                style={{ width: "75%", height: "75%" }}
              />
            </Button>
          </OverlayTrigger>
        </Col>
      </Row>
    </Container>
  );
};

export default AddressesFillingHourlyIntervalsButtons;

